import Cookies from '@comeon/tomcat-cookies';

function set(key: string, value: unknown) {
	const stringValue = JSON.stringify(value);
	try {
		sessionStorage.setItem(key, stringValue);
	} catch {
		Cookies.set(key, stringValue);
	}
}

const get = <T = unknown>(key: string): T | null => {
	const sessionValue = sessionStorage.getItem(key);
	const cookieValue = Cookies.get(key);
	return JSON.parse(sessionValue ?? cookieValue ?? 'null') as T;
};

function remove(key: string) {
	sessionStorage.removeItem(key);
	Cookies.remove(key);

	return get(key);
}

export default { set, get, remove };
